import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "form-dialog__title" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "上传发票")
], -1)
const _hoisted_2 = {
  class: "form-dialog__content",
  style: {"display":"block"}
}
const _hoisted_3 = { style: {"margin-left":"20px"} }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "票面金额", -1)
const _hoisted_5 = { style: {"margin-left":"20px"} }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "发票号码", -1)

import { defineModel, withDefaults, ref } from 'vue';
import {
  BaseForm,
  BaseFormItem,
  BaseInput,
  BaseImage,
  BaseUpload,
  BaseIcon,
  BaseInputNumber
} from 'xrk-components';
import { uploadApi } from '@data-source/common/apis';
import { IndustryDetailData } from '@V/invoice/src/data-source/types';
import { DeleteFilled } from '@element-plus/icons-vue';
import { useRecognition } from '@V/invoice/src/hooks';


export default /*#__PURE__*/_defineComponent({
  __name: 'invoice-offline-dialog-file',
  props: /*#__PURE__*/_mergeModels({
    disabled: { type: Boolean }
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any, { expose: __expose }) {



const modelValue = _useModel<IndustryDetailData>(__props, "modelValue");
const formRef = ref(null);

const formRules = {
  imgList: [
    {
      required: true,
      trigger: 'change',
      validator: (rule, v, callback) => {
        if (!v?.length) {
          return callback(new Error('请上传发票'));
        }
        if (v.some(item => !item.invoicePic)) {
          return callback(new Error('发票上传失败，请重新上传'));
        }
        if (v.some(item => !item.invoiceNo || !item.invoiceAmount)) {
          return callback(new Error('请填写发票信息'));
        }
        callback();
      }
    }
  ],
  fileList: [
    {
      required: false,
      trigger: 'change',
      validator: (rule, v, callback) => {
        if (v.some(item => !item.fileUrl)) {
          return callback(new Error('材料上传失败，请重新上传'));
        }
        callback();
      }
    }
  ]
};

const onImgChange = async v => {
  const { response } = v;
  if (response && response.data.fileUrl) {
    const ocr = await useRecognition(response.data.fileUrl);
    modelValue.value.imgList.push({
      imgDetailId: null,
      invoicePic: response.data.fileUrl,
      ...ocr
    });
  }
  formRef.value.validate('imgList');
};
const onImgRemove = index => {
  modelValue.value.imgList.splice(index, 1);
  formRef.value.validate('imgList');
};
const onFilePreview = v => {
  window.open(v.url);
};

__expose({
  validate: (...args: any) => formRef.value?.validate(...args)
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BaseForm), {
    ref_key: "formRef",
    ref: formRef,
    "label-position": "top",
    scrollToError: "",
    model: modelValue.value,
    rules: formRules
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(BaseFormItem), {
          label: "发票照片",
          prop: "imgList"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              (!_ctx.disabled)
                ? (_openBlock(), _createBlock(_unref(BaseUpload), {
                    key: 0,
                    style: {"margin-bottom":"20px"},
                    autoUpload: "",
                    btnText: "上传发票",
                    tipText: "只能上传jpg/png，且每份不超过50MB",
                    listType: null,
                    accept: ['.jpg', '.jpeg', '.png', '.JPG', '.JPEG', '.PNG'],
                    limit: 20,
                    limitSize: 50,
                    multiple: false,
                    showFileList: false,
                    "http-request": _unref(uploadApi),
                    onChange: onImgChange
                  }, null, 8, ["http-request"]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(modelValue.value.imgList, (img, imgIndex) => {
                return (_openBlock(), _createElementBlock("div", {
                  style: {"position":"relative","display":"flex","align-items":"flex-end","margin-bottom":"30px"},
                  key: img.invoicePic
                }, [
                  _createVNode(_unref(BaseImage), {
                    style: {"width":"200px","height":"120px"},
                    src: img.invoicePic,
                    "preview-src-list": [img.invoicePic]
                  }, null, 8, ["src", "preview-src-list"]),
                  _createElementVNode("div", _hoisted_3, [
                    _hoisted_4,
                    _createVNode(_unref(BaseInputNumber), {
                      style: {"width":"240px","display":"block"},
                      placeholder: "请输入",
                      disabled: _ctx.disabled,
                      controls: false,
                      precision: 2,
                      min: 0,
                      max: 999999999,
                      modelValue: img.invoiceAmount,
                      "onUpdate:modelValue": ($event: any) => ((img.invoiceAmount) = $event)
                    }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    _hoisted_6,
                    _createVNode(_unref(BaseInput), {
                      style: {"width":"240px"},
                      disabled: _ctx.disabled,
                      modelValue: img.invoiceNo,
                      "onUpdate:modelValue": ($event: any) => ((img.invoiceNo) = $event)
                    }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"])
                  ]),
                  (!_ctx.disabled)
                    ? (_openBlock(), _createBlock(_unref(BaseIcon), {
                        key: 0,
                        size: "18",
                        color: "#ED7067",
                        style: {"cursor":"pointer","position":"absolute","right":"-35px","bottom":"10px"},
                        onClick: ($event: any) => (onImgRemove(imgIndex))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(DeleteFilled))
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ])
          ]),
          _: 1
        }),
        (!_ctx.disabled || modelValue.value.fileList.length)
          ? (_openBlock(), _createBlock(_unref(BaseFormItem), {
              key: 0,
              label: "其他材料",
              prop: "fileList"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BaseUpload), {
                  style: {"margin-bottom":"20px"},
                  listType: "text",
                  autoUpload: "",
                  showFileList: "",
                  btnText: "添加文件",
                  tipText: 
            _ctx.disabled ? '' : '只能上传png/jpg/jpeg/pdf/bmp文件，且每份不超过50MB'
          ,
                  accept: ['.jpg', '.jpeg', '.png', '.pdf', '.bmp'],
                  limit: _ctx.disabled ? 1 : 10,
                  limitSize: 50,
                  multiple: false,
                  "http-request": _unref(uploadApi),
                  disabled: _ctx.disabled,
                  uploadBtnProps: {
            limitOverHide: true
          },
                  keys: { name: 'fileName', url: 'fileUrl' },
                  fileList: modelValue.value.fileList,
                  "onUpdate:fileList": _cache[0] || (_cache[0] = ($event: any) => ((modelValue.value.fileList) = $event)),
                  onPreview: onFilePreview
                }, null, 8, ["tipText", "limit", "http-request", "disabled", "fileList"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["model"]))
}
}

})